import React from "react";

import styles from "./badgeLarge.module.scss";

type BaseLargeProps = {
	variant: "primary" | "success" | "danger" | "warning" | "light";
	children: string | JSX.Element;
};

const BadgeLarge = ({ variant = "primary", children }: BaseLargeProps) => {
	return (
		<div className={`${styles.container} ${styles[variant]}`}>
			{children}
		</div>
	);
};

export default BadgeLarge;
